import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nbspRemove',
})
export class NbspRemovePipe implements PipeTransform {
  transform(value: string | unknown): string | unknown {
    return typeof value === 'string' ? value.replace(/&nbsp;/g, ' ') : value;
  }
}
